"use client"

import { Album } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `AlbumIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const AlbumIcon = component(Icon)({ as: Album })
